// extracted by mini-css-extract-plugin
export default {"scriptRoot":"Script_scriptRoot__pWh6e","scene":"Script_scene__IkLCc","inspectorContentRoot":"Script_inspectorContentRoot__tmuYB","imgContainer":"Script_imgContainer__+-c0V"};